import type { UseMutateFunction } from "@tanstack/react-query";

import { PaymentsCreateOrderAttributes, PaymentsProduct } from "~/api/Api";

import { Icon } from "../../../assets/icons/Icon";
import styles from "../brandLinksPackage/BrandLinksPackage.module.scss";
import { FeatureSection } from "../featureSection/FeatureSection";
import { PricingCard } from "../pricingCard/PricingCard";

const text = [
  {
    title: "AI Citations",
    description:
      "Using your brand and topic information, we build 13 LLM indexable content pages and documents on the AI web (Perplexity, Claude, ChatGPT, Gemini, Notion, etc.). We then build 250 secondary citations on branded pages to create additional reference to those content pieces.",
  },
  {
    title: "PR News Citations",
    description:
      "We craft a Press Release on your brand and topic to be published across 200+ news media websites for traditional prestige media brand affiliation in the LLM training set.",
  },
  {
    title: "That’s it!",
    description:
      "Your citations will be automatically added to your site's Built Link Reports. You can typically expect full delivery within 60 days, and we'll let you know when we're done. So sit back, relax and let us handle this part of your business.",
  },
];

interface BrandLinksPackageProps {
  product: PaymentsProduct;
  targetSites: { value: string; label: string }[];
  createOrder: UseMutateFunction<
    unknown,
    unknown,
    PaymentsCreateOrderAttributes,
    unknown
  >;
  isCreateOrderPending: boolean;
}
const descriptionList = [
  "13 AI Citations",
  "250 Secondary Citations",
  "Press Release Syndicated Across 200+ news sites",
];

export const LlmCitationsPackage = ({
  product,
  targetSites,
  createOrder,
  isCreateOrderPending,
}: BrandLinksPackageProps) => {
  return (
    <div className={styles.brandLinksPackage}>
      <main className={styles.brandLinksPackageMain}>
        <div className={styles.brandLinksGrid}>
          <section className={styles.descriptionCard}>
            <div className={styles.descriptionWrapper}>
              <div className={styles.descriptionContent}>
                <div className={styles.brandLinksImage}>
                  <Icon
                    iconName="BrandLinksImage1"
                    width="19.125rem"
                    height="12.5rem"
                  />
                </div>

                <div className={styles.descriptionTextContainer}>
                  <p className={styles.descriptionText}>
                    The LLM Citations Service is a link-building and PR package
                    designed to improve your brand’s authority and topical
                    relevancy for AI search on Chat GPT, Gemini, Perplexity, and
                    Claude.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.brandLinksPackagePricing}>
            {product.prices?.map((price) => (
              <PricingCard
                key={price.id}
                price={price}
                targetSites={targetSites}
                createOrder={createOrder}
                list={descriptionList}
                isCreateOrderPending={isCreateOrderPending}
              />
            ))}
          </section>
        </div>
        <FeatureSection
          icon="BrandLinksImage2"
          title="How does it work?"
          text={text}
          reversed
        />
      </main>
    </div>
  );
};
